export default __webpack_public_path__ + "static/media/dog-selected.980867b1.svg";